/** More markers than this crowd a preview-sized route map. */
export const MAX_PREVIEW_WALKERS = 5;
/**
 * Real participants for a route preview shown to a member who has not joined
 * yet, each at their progress along the route. Scores beyond the target stand
 * at the finish rather than wrapping to the start.
 *
 * Built from the challenge leaderboards, which are visible pre-join and only
 * carry members who consented to appear in standings, so a preview never shows
 * anyone the standings would not. The route board is preferred because its
 * score is route-window steps, the same numerator the route fraction uses.
 */
export function challengeRoutePreviewWalkers(leaderboards, route) {
    if (!leaderboards || route.target <= 0)
        return [];
    const board = leaderboards.leaderboards.find((b) => b.periodKind === "route") ?? leaderboards.leaderboards[0];
    if (!board)
        return [];
    return board.entries.slice(0, MAX_PREVIEW_WALKERS).map((entry) => ({
        id: entry.userId,
        displayName: entry.displayName,
        initials: entry.initials,
        avatarUrl: entry.avatarUrl,
        avatarColor: entry.avatarColor,
        progressFraction: Math.min(1, entry.score / route.target),
        steps: entry.score,
        distanceMeters: entry.distanceMeters,
        groupIds: [],
        groupNames: [],
    }));
}
//# sourceMappingURL=challenge-route-preview.js.map